type ValidationResult = {
  isValid: boolean;
  message: string;
};

export const validateEmail = (email: string): ValidationResult => {
  if (!email) {
    return {
      isValid: false,
      message: 'Email tidak boleh kosong',
    };
  }

  if (!/\S+@\S+\.\S+/.test(email)) {
    return {
      isValid: false,
      message: 'Format email tidak valid',
    };
  }

  return {
    isValid: true,
    message: '',
  };
};

export const validatePhone = (phone: string): ValidationResult => {
  if (!phone) {
    return {
      isValid: false,
      message: 'Nomor HP tidak boleh kosong',
    };
  }

  if (!/^[0-9]{10,13}$/.test(phone)) {
    return {
      isValid: false,
      message: 'Nomor HP tidak valid (10-13 digit)',
    };
  }

  return {
    isValid: true,
    message: '',
  };
};
